function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from './utils/thirdParty/wrapper';
import noop from 'lodash/noop';
import { THEME_PROP_TYPE } from './constants';

var Captcha =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Captcha, _React$PureComponent);

  function Captcha() {
    _classCallCheck(this, Captcha);

    return _possibleConstructorReturn(this, _getPrototypeOf(Captcha).apply(this, arguments));
  }

  _createClass(Captcha, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sitekey = _this$props.sitekey,
          onChange = _this$props.onChange,
          onExpired = _this$props.onExpired,
          theme = _this$props.theme;
      return React.createElement(ReCAPTCHA, {
        className: "eds-captcha",
        sitekey: sitekey,
        onChange: onChange,
        onExpired: onExpired,
        theme: theme
      });
    }
  }]);

  return Captcha;
}(React.PureComponent);

_defineProperty(Captcha, "propTypes", {
  /**
   * The sitekey registered withe Google recaptcha for use w/ component
  */
  sitekey: PropTypes.string.isRequired,

  /**
  * The function that should trigger when the captcha changes
  */
  onChange: PropTypes.func,

  /**
  * The function that should trigger when captcha is expired
  */
  onExpired: PropTypes.func,

  /**
  * The visual theme for the captcha
  */
  theme: THEME_PROP_TYPE
});

_defineProperty(Captcha, "defaultProps", {
  onChange: noop,
  theme: 'light'
});

export { Captcha as default };